/*
 * Deskon - the pop-up player behind the three video bubbles (snippets/deskon-video-stories.liquid).
 *
 * ONE PLAYER FOR THE WHOLE PAGE, built on the first click and appended to <body>. Keeping it out
 * of the buy box matters: that column is re-rendered on every variant change, and a <dialog>
 * living inside it would be thrown away mid-play. Clicks are caught by delegation on document for
 * the same reason - the bubbles themselves are replaced by those re-renders.
 *
 * THE VIDEOS CHAIN: the end of one starts the next; after the third the player stays on its last
 * frame. Sound is on, because the pop-up only ever opens from a tap - if a browser still refuses,
 * it falls back to muted rather than not playing, and the mute button shows the state.
 *
 * NOTHING LOADS BEFORE THE CLICK. The source is set when a video is shown and removed on close,
 * so a closed pop-up keeps downloading nothing.
 *
 * THE PLAYER TAKES EACH VIDEO'S OWN SHAPE (19/10/2026): the frame gets --dk-vs-ratio (width /
 * height) from the Liquid data, then from the file itself once its metadata is in. A vertical
 * video gets a vertical player, a 16:9 one a 16:9 player - no black bars either way.
 *
 * THE PROGRESS BARS ARE BUTTONS (19/10/2026): a click on a bar plays that video. Each bar is a
 * 20px-tall button around its 2px line, so it is easy to hit on a phone.
 *
 * DOWNLOAD DETERRENTS (19/10/2026, user's request): no context menu (right click / long press,
 * where "Save video as" lives) and no dragging, on the bubbles and the pop-up; the video has
 * download, picture-in-picture and casting switched off. This stops casual saving only - anything
 * a browser plays can still be recorded by someone determined.
 *
 * Desktop: centred player, arrows either side. Phones (under 750px): full-width player,
 * swipe left / right, no arrows. Esc, the close button or a click on the dark backdrop closes.
 */
(function () {
  'use strict';

  if (window.__dkVideoStories) return;
  window.__dkVideoStories = true;

  var ICON_CLOSE =
    '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M2 2 14 14M14 2 2 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var ICON_PREV =
    '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M10 3 5 8l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_NEXT =
    '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_SOUND =
    '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M3 8v4h3l4 3.5v-11L6 8H3Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>' +
    '<path d="M13.5 7.2a4 4 0 0 1 0 5.6M15.6 5.2a7 7 0 0 1 0 9.6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
  var ICON_MUTED =
    '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M3 8v4h3l4 3.5v-11L6 8H3Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>' +
    '<path d="M13.5 8l4 4M17.5 8l-4 4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';

  var modal = null;
  var frameEl = null;
  var video = null;
  var bars = null;
  var counter = null;
  var muteBtn = null;
  var prevBtn = null;
  var nextBtn = null;
  var items = [];
  var index = 0;
  var muted = false;
  var raf = 0;
  var touchX = null;
  var touchY = null;

  function isPhone() {
    return window.innerWidth < 750;
  }

  function build() {
    modal = document.createElement('dialog');
    modal.className = 'dk-vs-modal';
    modal.setAttribute('aria-label', 'Product videos');
    modal.innerHTML =
      '<div class="dk-vs-modal__stage">' +
      '<button type="button" class="dk-vs-modal__close" aria-label="Close videos">' + ICON_CLOSE + '</button>' +
      '<div class="dk-vs-modal__frame">' +
      '<div class="dk-vs-modal__bars"></div>' +
      '<div class="dk-vs-modal__player">' +
      '<video playsinline preload="none" disablepictureinpicture disableremoteplayback' +
      ' controlslist="nodownload noplaybackrate noremoteplayback"></video>' +
      '<button type="button" class="dk-vs-modal__nav dk-vs-modal__nav--prev" aria-label="Previous video">' + ICON_PREV + '</button>' +
      '<button type="button" class="dk-vs-modal__nav dk-vs-modal__nav--next" aria-label="Next video">' + ICON_NEXT + '</button>' +
      '</div>' +
      '<div class="dk-vs-modal__bar">' +
      '<button type="button" class="dk-vs-modal__mute"></button>' +
      '<span class="dk-vs-modal__count"></span>' +
      '</div>' +
      '</div>' +
      '</div>';
    document.body.appendChild(modal);

    video = modal.querySelector('video');
    video.disablePictureInPicture = true;
    video.disableRemotePlayback = true;
    bars = modal.querySelector('.dk-vs-modal__bars');
    counter = modal.querySelector('.dk-vs-modal__count');
    muteBtn = modal.querySelector('.dk-vs-modal__mute');
    prevBtn = modal.querySelector('.dk-vs-modal__nav--prev');
    nextBtn = modal.querySelector('.dk-vs-modal__nav--next');

    modal.querySelector('.dk-vs-modal__close').addEventListener('click', close);
    bars.addEventListener('click', function (event) {
      var seg = event.target.closest ? event.target.closest('.dk-vs-modal__seg') : null;
      if (seg) go(parseInt(seg.getAttribute('data-index'), 10));
    });
    prevBtn.addEventListener('click', function () { go(index - 1); });
    nextBtn.addEventListener('click', function () { go(index + 1); });
    muteBtn.addEventListener('click', function () {
      muted = !muted;
      video.muted = muted;
      paintMute();
    });

    /* The stage covers the whole dialog, so a click that lands on it - not on the frame or a
       button - is a click on the dark backdrop. */
    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.classList.contains('dk-vs-modal__stage')) close();
    });
    modal.addEventListener('close', cleanup);
    modal.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') go(index + 1);
      if (event.key === 'ArrowLeft') go(index - 1);
    });

    video.addEventListener('ended', function () {
      if (index < items.length - 1) {
        go(index + 1);
      } else {
        paintBars(1);
      }
    });
    video.addEventListener('play', loop);
    video.addEventListener('pause', function () { cancelAnimationFrame(raf); });
    video.addEventListener('click', function () {
      if (video.paused) {
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    });

    var frame = modal.querySelector('.dk-vs-modal__frame');
    frameEl = frame;
    video.addEventListener('loadedmetadata', function () {
      if (video.videoWidth && video.videoHeight) setRatio(video.videoWidth / video.videoHeight);
    });
    frame.addEventListener('touchstart', function (event) {
      touchX = event.touches[0].clientX;
      touchY = event.touches[0].clientY;
    }, { passive: true });
    frame.addEventListener('touchend', function (event) {
      if (touchX === null) return;
      var dx = event.changedTouches[0].clientX - touchX;
      var dy = event.changedTouches[0].clientY - touchY;
      touchX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? index + 1 : index - 1);
    }, { passive: true });
  }

  function setRatio(value) {
    var ratio = parseFloat(value);
    if (!(ratio > 0)) ratio = 16 / 9;
    frameEl.style.setProperty('--dk-vs-ratio', ratio.toFixed(4));
  }

  function paintMute() {
    muteBtn.innerHTML = muted ? ICON_MUTED : ICON_SOUND;
    muteBtn.setAttribute('aria-label', muted ? 'Turn sound on' : 'Turn sound off');
  }

  function paintBars(progress) {
    var fills = bars.querySelectorAll('.dk-vs-modal__fill');
    for (var i = 0; i < fills.length; i += 1) {
      var width = i < index ? 1 : i > index ? 0 : progress;
      fills[i].style.width = (width * 100).toFixed(2) + '%';
    }
  }

  function loop() {
    cancelAnimationFrame(raf);
    var step = function () {
      if (video.duration) paintBars(Math.min(1, video.currentTime / video.duration));
      if (!video.paused && !video.ended) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
  }

  function go(next) {
    if (next < 0 || next >= items.length) return;
    index = next;
    var item = items[index];
    video.pause();
    setRatio(item.ratio);
    video.poster = item.poster || '';
    video.src = isPhone() ? item.sd || item.hd : item.hd || item.sd;
    video.muted = muted;
    counter.textContent = index + 1 + ' / ' + items.length;
    prevBtn.disabled = index === 0;
    nextBtn.disabled = index === items.length - 1;
    paintBars(0);

    var attempt = video.play();
    if (attempt && attempt.catch) {
      attempt.catch(function () {
        /* Sound refused by the browser: play muted rather than not at all. */
        muted = true;
        video.muted = true;
        paintMute();
        video.play().catch(function () {});
      });
    }
  }

  function open(list, start) {
    if (!modal) build();
    items = list;
    bars.innerHTML = '';
    for (var i = 0; i < items.length; i += 1) {
      var seg = document.createElement('button');
      seg.type = 'button';
      seg.className = 'dk-vs-modal__seg';
      seg.setAttribute('data-index', String(i));
      seg.setAttribute('aria-label', 'Play video ' + (i + 1) + ' of ' + items.length);
      seg.innerHTML = '<span class="dk-vs-modal__track"><span class="dk-vs-modal__fill"></span></span>';
      bars.appendChild(seg);
    }
    paintMute();
    document.documentElement.classList.add('dk-vs-lock');
    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
    go(start);
  }

  function close() {
    if (!modal) return;
    if (typeof modal.close === 'function' && modal.open) {
      modal.close();
    } else {
      modal.removeAttribute('open');
      cleanup();
    }
  }

  function cleanup() {
    cancelAnimationFrame(raf);
    video.pause();
    video.removeAttribute('src');
    video.load();
    document.documentElement.classList.remove('dk-vs-lock');
  }

  /* No "Save video as" menu and no dragging the video or a preview out of the page. */
  function isOurs(target) {
    return !!(target && target.closest && target.closest('.dk-vs, .dk-vs-modal'));
  }
  document.addEventListener('contextmenu', function (event) {
    if (isOurs(event.target)) event.preventDefault();
  });
  document.addEventListener('dragstart', function (event) {
    if (isOurs(event.target)) event.preventDefault();
  });

  document.addEventListener('click', function (event) {
    var bubble = event.target.closest ? event.target.closest('.dk-vs__bubble') : null;
    if (!bubble) return;
    event.preventDefault();
    var root = bubble.closest('[data-dk-vs]');
    var data = root ? root.querySelector('script[data-dk-vs-data]') : null;
    if (!data) return;
    var list;
    try {
      list = JSON.parse(data.textContent);
    } catch (error) {
      return;
    }
    if (!list || !list.length) return;
    open(list, parseInt(bubble.getAttribute('data-dk-vs-index'), 10) || 0);
  });
})();